import { IEntity } from '../interfaces/entity';
import { User } from './user';

export enum enumReviewStatus {
  None = 0,
  Pending = 10,
  Accepted = 20,
  Rejected = 30,
  Reviewed = 40,
}

export interface IReviewList{
  items: Review[];
  totalCount: number;
}

export class Review implements IEntity {
  id: number;
  uid: string;
  label: string;
  status: number;
  reviewDate: string;
  reviewedById: number;
  reviewedBy: User;
  comments: string;
  override: boolean;
  overrideReason: string;
  canDelete: boolean;
}
